import { useEffect } from "react";
import { useLocomotiveScroll } from "react-locomotive-scroll";
import { useRecoilState } from "recoil";
import { projectLinkState } from "../../../infrastructure/states/projectLinkState";
import { NavLink } from "../../../infrastructure/types/navLink";
import { Project } from "../../../infrastructure/types/project";
import NavbarLinks from "../Navbar/navbar-links";
import Flex from "../ui/Flex/Flex";
import Gradient from "../ui/Gradient/Gradient";
import ProjectsList from "./projectsList";
import "./style.scss";

type ProjectsProps = {
  projects: Project[];
};

const Projects = ({ projects }: ProjectsProps): JSX.Element => {
  const [activeProjectLink, setActiveProjectLink] =
    useRecoilState(projectLinkState);
  const links: NavLink[] = projects.map((p: Project, index: number) => {
    return {
      link: p.project_title,
      id:
        "#" +
        p.project_title
          .toLowerCase()
          .split(" ")
          .join("-")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, ""),

      index,
    };
  });

  useEffect(() => {
    if (activeProjectLink.link === undefined) {
      setActiveProjectLink(links[0]);
    }
  }, [setActiveProjectLink, activeProjectLink.link, links]);

  const { scroll: S } = useLocomotiveScroll();
  useEffect(() => {
    if (S) {
      S.scrollTo(activeProjectLink.id, { duration: 700 });
    }
  }, [activeProjectLink, S]);

  return (
    <div data-scroll-section id="mes-travaux">
      <div
        id="projects"
        data-scroll
        data-scroll-call="#mes-travaux"
        data-scroll-repeat
      >
        <div
          className="projects-content"
          data-scroll
          data-scroll-sticky
          data-scroll-target="#projects"
        >
          <Flex gap={0} column alignCenter>
            <Flex gap={10} column>
              <div className="font-weight-3" data-scroll data-scroll-repeat>
                <Gradient>mes travaux</Gradient>
                <h3 className="text-title-3 font-weight-3">
                  Créations UI & UX
                </h3>
              </div>
              <NavbarLinks
                links={links}
                activeLinkIndex={activeProjectLink.index}
                setActiveLink={setActiveProjectLink}
              />
            </Flex>
          </Flex>
        </div>
        <ProjectsList projects={projects} />
      </div>
    </div>
  );
};

export default Projects;
